export default __webpack_public_path__ + "static/media/pokiExcavatorRover.eaf90931.png";